<template>
  <div class="main-layout">
    <!-- 左侧导航栏 — 白色 + 右侧规则线 -->
    <div class="sidebar-panel" :class="{ collapsed: isCollapse }">
      <div class="sidebar-header">
        <img src="../../assets/xiaohui.png" alt="校徽" class="sidebar-logo" />
        <span v-show="!isCollapse" class="sidebar-title">HFLIBS可视化分析系统</span>
      </div>

      <div class="sidebar-nav">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="nav-item"
          :class="{ active: activeMenu === item.path }"
        >
          <i :class="item.icon"></i>
          <span v-show="!isCollapse" class="nav-label">{{ item.label }}</span>
          <span v-show="!isCollapse && activeMenu === item.path" class="nav-indicator"></span>
        </router-link>
      </div>

      <div class="sidebar-footer" v-show="!isCollapse">
        <span class="sidebar-version">v6.1.2</span>
      </div>
    </div>

    <!-- 右侧内容区域 -->
    <div class="main-content">
      <div class="top-bar">
        <div class="top-bar-left">
          <i
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="collapse-btn"
            @click="isCollapse = !isCollapse"
          ></i>
          <span class="top-team">山东大学-行星科学团队 — 管理后台</span>
        </div>
        <div class="top-bar-right">
          <span class="top-datetime">{{ dateTimeText }}</span>
          <el-dropdown trigger="hover" @command="handleCommand" class="user-dropdown">
            <span class="user-trigger">
              <i class="el-icon-user-solid"></i>
              {{ userInfo.userName || '管理员' }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>
                <span style="color: var(--text-muted);">{{ userInfo.role || '管理员' }}</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="personal">
                <i class="el-icon-user"></i> 个人中心
              </el-dropdown-item>
              <el-dropdown-item command="changePassword">
                <i class="el-icon-lock"></i> 修改密码
              </el-dropdown-item>
              <el-dropdown-item divided command="switchAccount">
                <i class="el-icon-switch-button"></i> 退出
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="page-content">
        <router-view />
      </div>
    </div>

    <!-- 修改密码对话框 -->
    <el-dialog :visible.sync="pwdDialogVisible" title="修改密码" width="440px" append-to-body :close-on-click-modal="false">
      <el-form ref="pwdFormRef" :model="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password placeholder="请输入旧密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password placeholder="请输入新密码（至少3位）" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="pwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitChangePassword" :loading="pwdSubmitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.main-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--bg-primary);
}

/* ---- 侧边栏 ---- */
.sidebar-panel {
  width: 240px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F0EDE8;
  border-right: 1px solid var(--border-subtle);
  flex-shrink: 0;
  transition: width var(--transition-slow);
  z-index: 20;
}
.sidebar-panel.collapsed { width: 66px; }

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 0 12px;
  border-bottom: 1px solid var(--border-subtle);
}
.sidebar-logo {
  width: 34px; height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sidebar-title {
  margin-left: 8px;
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 0.03em;
  white-space: nowrap;
}

/* 导航项 */
.sidebar-nav {
  flex: 1;
  padding: 12px 8px;
  overflow-y: auto;
}
.nav-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 2px;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  position: relative;
  transition: all var(--transition-fast);
}
.nav-item:hover {
  color: var(--accent-primary);
  background: var(--accent-primary-soft);
}
.nav-item.active {
  color: var(--accent-primary);
  background: var(--accent-primary-soft);
  font-weight: 500;
}
.nav-item i { font-size: 1.1rem; width: 22px; text-align: center; flex-shrink: 0; }
.nav-label { margin-left: 10px; white-space: nowrap; }
.nav-indicator {
  position: absolute; left: 0; top: 50%; transform: translateY(-50%);
  width: 3px; height: 20px; border-radius: 0 3px 3px 0;
  background: var(--accent-primary);
}

.sidebar-footer {
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle);
}
.sidebar-version {
  font-size: 0.72rem; color: var(--text-muted);
  font-family: var(--font-mono);
}

/* ---- 主内容区 ---- */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ---- 顶部栏 ---- */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
  flex-shrink: 0;
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border-subtle);
  z-index: 10;
}
.top-bar-left { display: flex; align-items: center; gap: 14px; }

.collapse-btn {
  font-size: 1.2rem;
  color: var(--text-muted);
  cursor: pointer;
  transition: color var(--transition-fast);
  padding: 4px;
  border-radius: var(--radius-sm);
}
.collapse-btn:hover { color: var(--accent-primary); }

.top-team {
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-weight: 500;
  letter-spacing: 0.02em;
}

.top-bar-right { display: flex; align-items: center; gap: 20px; }

.top-datetime {
  font-size: 0.75rem;
  color: var(--text-muted);
  font-family: var(--font-mono);
  letter-spacing: 0.03em;
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.85rem;
  color: var(--text-secondary);
  padding: 5px 10px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}
.user-trigger:hover { color: var(--accent-primary); }

/* ---- 页面内容 ---- */
.page-content {
  flex: 1;
  overflow-y: auto;
  padding: 32px 32px 40px;
}

/* ---- 响应式 ---- */
@media screen and (max-width: 768px) {
  .sidebar-panel { width: 66px; }
  .sidebar-title, .nav-label, .sidebar-footer, .sidebar-version { display: none; }
  .top-team { display: none; }
  .top-datetime { font-size: 0.7rem; }
  .page-content { padding: 16px; }
  .top-bar { padding: 0 16px; }
}
</style>

<script>
export default {
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.pwdForm.newPassword) { callback(new Error('两次输入不一致')); } else { callback(); }
    };
    const validateNewPwd = (rule, value, callback) => {
      if (value && value === this.pwdForm.oldPassword) { callback(new Error('新密码不能与原密码相同')); } else { callback(); }
    };
    return {
      isCollapse: false,
      dateTimeText: '',
      dateTimeTimer: null,
      userInfo: { userId: '', userName: '', role: '' },
      pwdDialogVisible: false, pwdSubmitting: false,
      pwdForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, min: 3, message: '新密码至少3位', trigger: 'blur' }, { validator: validateNewPwd, trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请确认新密码', trigger: 'blur' }, { validator: validateConfirm, trigger: 'blur' }]
      },
      menuItems: [
        { path: '/admin/home', icon: 'el-icon-s-home', label: '首页' },
        { path: '/admin/announcement', icon: 'el-icon-bell', label: '公告管理' },
        { path: '/admin/users', icon: 'el-icon-user-solid', label: '成员信息管理' },
        { path: '/admin/logs', icon: 'el-icon-document', label: '系统日志管理' },
        { path: '/admin/models', icon: 'el-icon-cpu', label: 'YOLO模型管理' },
        { path: '/admin/vision', icon: 'el-icon-view', label: '计算机视觉分析' },
        { path: '/admin/video', icon: 'el-icon-video-camera', label: '实验视频传输' }
      ]
    }
  },

  computed: {
    activeMenu() { return this.$route.path; }
  },

  created() {
    this.updateDateTime();
    this.dateTimeTimer = setInterval(() => { this.updateDateTime(); }, 1000);
    this.fetchUserInfo();
  },

  beforeDestroy() {
    if (this.dateTimeTimer) { clearInterval(this.dateTimeTimer); this.dateTimeTimer = null; }
  },

  methods: {
    updateDateTime() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      const hh = String(now.getHours()).padStart(2, '0');
      const mm = String(now.getMinutes()).padStart(2, '0');
      const ss = String(now.getSeconds()).padStart(2, '0');
      const weekMap = ['日', '一', '二', '三', '四', '五', '六'];
      this.dateTimeText = `${y}年${m}月${d}日 ${hh}:${mm}:${ss} 星期${weekMap[now.getDay()]}`;
    },

    async fetchUserInfo() {
      try {
        const resp = await this.$axios.get('/adm/info');
        if (resp.data.code === 0) { this.userInfo = resp.data.data; }
      } catch (e) { console.warn('获取管理员信息失败:', e); }
    },

    handleCommand(command) {
      if (command === 'personal') {
        this.$router.push('/personal-center');
      } else if (command === 'changePassword') {
        this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
        this.pwdDialogVisible = true;
        this.$nextTick(() => { if (this.$refs.pwdFormRef) this.$refs.pwdFormRef.clearValidate(); });
      } else if (command === 'switchAccount') {
        this.$axios.post('/api/session/destroy').finally(() => {
          this.$router.push('/login');
          this.$message.success('已退出登录');
        });
      }
    },

    async submitChangePassword() {
      const valid = await this.$refs.pwdFormRef.validate().catch(() => false);
      if (!valid) return;
      this.pwdSubmitting = true;
      try {
        const resp = await this.$axios.put('/adm/changePassword', this.pwdForm);
        if (resp.data.code === 0) {
          this.pwdDialogVisible = false;
          this.$message.success('密码修改成功，请重新登录');
          this.$axios.post('/api/session/destroy').finally(() => {
            this.$router.push('/login');
          });
        } else { this.$message.error(resp.data.msg || '修改失败'); }
      } catch (e) { this.$message.error('修改密码失败'); } finally { this.pwdSubmitting = false; }
    }
  }
}
</script>
